import React from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import {
  LuCircleCheck,
  LuClipboardList,
  LuLayoutDashboard,
  LuPlus,
  LuTicket,
} from "react-icons/lu";
import B2BHubHomeHeader from "../../components/B2BHubHomeHeader";
import HubHomeFooter from "../../components/hub/HubHomeFooter";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/styles/home.scss";
import "../../assets/styles/raise_support_ticket.scss";

function formatDateTime(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export default function TicketCreatedSuccessPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state || {};

  if (!state.ticketNumber) {
    return <Navigate to="/help-center/raise-ticket" replace />;
  }

  return (
    <div className="raise-ticket-page">
      <B2BHubHomeHeader />
      <main className="raise-ticket-main">
        <section className="ticket-success-card">
          <div className="ticket-success-card__icon" aria-hidden>
            <LuCircleCheck />
          </div>
          <h1>Ticket Created Successfully</h1>
          <p>
            Your support request has been logged. Our team will review it and get back to you within
            the expected response time.
          </p>

          <dl className="ticket-success-meta">
            <div>
              <dt>Ticket Number</dt>
              <dd>{state.ticketNumber}</dd>
            </div>
            <div>
              <dt>Category</dt>
              <dd>{state.category || "—"}</dd>
            </div>
            <div>
              <dt>Priority</dt>
              <dd>{state.priority || "—"}</dd>
            </div>
            <div>
              <dt>Current Status</dt>
              <dd>
                <span className="ticket-success-status">{state.status || "New"}</span>
              </dd>
            </div>
            <div>
              <dt>Expected Response Time</dt>
              <dd>{state.expectedResponseTime || "—"}</dd>
            </div>
            <div>
              <dt>Created Date &amp; Time</dt>
              <dd>{formatDateTime(state.createdAt)}</dd>
            </div>
          </dl>

          <div className="ticket-success-actions">
            <Link to="/dashboard/help-center/my-tickets" className="raise-ticket-btn raise-ticket-btn--primary">
              <LuClipboardList aria-hidden /> View My Tickets
            </Link>
            <button
              type="button"
              className="raise-ticket-btn raise-ticket-btn--ghost"
              onClick={() => navigate("/help-center/raise-ticket")}
            >
              <LuPlus aria-hidden /> Raise Another Ticket
            </button>
            <Link to="/dashboard" className="raise-ticket-btn raise-ticket-btn--ghost">
              <LuLayoutDashboard aria-hidden /> Go to Dashboard
            </Link>
          </div>

          <p className="ticket-success-hint">
            <LuTicket aria-hidden /> Keep your ticket number handy for follow-ups.
          </p>
        </section>
      </main>
      <HubHomeFooter />
    </div>
  );
}
